<template>
  <div>
    <div class="row">
      <div class="col-12" v-show="parametros_acuerdoSeleccionado.key > -1">
        <PDFDocument :url="parametros_acuerdoSeleccionado.rutaAcuerdo" :height="'650px'" :key="parametros_acuerdoSeleccionado.key" />
      </div>
      <div class="col-12" v-show="parametros_acuerdoSeleccionado.key == -1" style="height:650px; background-color:#2e2f31; border:solid;border-width:5px;">
        <div class="row" style="padding-top:15vh">
          <div class="col-3"></div>
          <div class="col-6">
            <div class="row">
              <h1>{{caratula.Juzgado}}</h1>
            </div>
            <div class="row">
              <div class="col-5"><h2>Expediente:</h2></div>
              <div class="col-7"><h2>{{caratula.NumeroExpediente}}</h2></div>
            </div>
            <div class="row">
              <div class="col-5"><h2>Naturaleza del Juicio:</h2></div>
              <div class="col-7"><h2>{{caratula.NaturalezaDelJuicio}}</h2></div>
            </div>
            <div class="row">
              <div class="col-5"><h2>Objeto del Juicio:</h2></div>
              <div class="col-7"><h2>{{caratula.ObjetoDelJuicio}}</h2></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end paginacion">
        <div v-if="parametros_acuerdoSeleccionado.key == -1" class="active">C</div>
        <div v-else @click="cambiarDocumentoMostrado(-1)">C</div>
        <template v-for="(documento) in documentosVisibles">
          <div v-if="documento.llave == parametros_acuerdoSeleccionado.key" class="active" v-bind:key="documento.llave">{{documento.llave+1}}</div>
          <div v-else @click="cambiarDocumentoMostrado(documento.llave)" v-bind:key="documento.llave">{{documento.llave+1}}</div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import store from '@/store/index'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'

  export default {
    data() {
      return {
        caratula: {
          NumeroExpediente: null,
          NaturalezaDelJuicio: null,
          ObjetoDelJuicio: null,
          Juzgado: null,
          FolioPapa: null
        },
        acuerdos: [],
        parametros_acuerdoSeleccionado: {
          rutaAcuerdo: "",
          key: ''
        },
        documentos: []
      }
    },
    props: {
      parametros: Object
    },
    mounted() {
      if (this.parametros.key != 0) {
        this.ObtenerCaratulaExpedienteElectronico();
        this.ObtenerExpedienteElectronico();
      }
    },
    components: {
      PDFDocument
    },
    methods: {
      ObtenerCaratulaExpedienteElectronico: function () {
        var peticion = {
          "esPrueba": false,
          "AreaId_Equitas": this.parametros.AreaId_Equitas,
          "Consecutivo": this.parametros.Consecutivo,
          "Ano": this.parametros.Ano,
          "TipoDocumentoId_Equitas": this.parametros.TipoDocumentoId_Equitas,
          "Numero": this.parametros.Numero,
          "AnoBusqueda": this.parametros.AnoBusqueda
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.ObtenerCaratulaExpedienteElectronico, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.caratula = response.data
            this.parametros_acuerdoSeleccionado.key = 0;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      ObtenerExpedienteElectronico: function () {
        var peticion = {
          "esPrueba": false,
          "AreaId_Equitas": this.parametros.AreaId_Equitas,
          "Consecutivo": this.parametros.Consecutivo,
          "Ano": this.parametros.Ano,
          "TipoDocumentoId_Equitas": this.parametros.TipoDocumentoId_Equitas,
          "Numero": this.parametros.Numero,
          "AnoBusqueda": this.parametros.AnoBusqueda
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.ObtenerExpedienteElectronico, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.acuerdos = response.data.ListaAcuerdos
            var documentos = [];
            if (this.acuerdos.length > 0) {
              this.acuerdos.forEach(function (acuerdo) {
                if (acuerdo.RutaArchivoAcuerdo != null) {
                  documentos.push(acuerdo.RutaArchivoAcuerdo);
                }
                if (acuerdo.RutaArchivoDigital != null) {
                  documentos.push(acuerdo.RutaArchivoDigital);
                }
              })
              this.documentos = documentos;
              this.cambiarDocumentoMostrado(-1);
            }
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      }, cambiarDocumentoMostrado: function (index) {
        if (index == -1) {
          this.parametros_acuerdoSeleccionado.rutaAcuerdo = "";
        }
        else {
          this.parametros_acuerdoSeleccionado.rutaAcuerdo = this.documentos[index];
        }
        this.parametros_acuerdoSeleccionado.key = index;
      }
    },
    computed: {
      documentosVisibles: function(){
        const copiaDocumentos = this.documentos.map((documento, index)=> {
          const nodo = {
            "llave": index,
            "ruta": documento
          }
          return nodo;
        });
        //console.log(copiaDocumentos);
        if(this.parametros_acuerdoSeleccionado.key <= 5 ){
          return copiaDocumentos.slice(0,(copiaDocumentos.length >= 10)? 9 : copiaDocumentos.length-1);
        }else{
          return copiaDocumentos.slice
          (this.parametros_acuerdoSeleccionado.key -5, 
          (copiaDocumentos.length-1 >= this.parametros_acuerdoSeleccionado.key+4)? this.parametros_acuerdoSeleccionado.key+4 : copiaDocumentos.length-1);
        }

      }
    },
    created() {

    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  .alinear_izq {
    float: left;
  }

  .alinear_der {
    float: right;
  }

  .contenedor-puntero {
    background: #212529;
    border-radius: 2px;
    padding: 10px;
    border: 1px solid white;
    margin-bottom: 1.5em;
  }
</style>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  #calendario_agendar_siccij .fc-view-container {
    background-color: transparent !important;
    color: #343a40 !important;
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-view table {
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-axis {
    background-color: #504f54;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
  }

  #calendario_agendar_siccij .fc-day-header {
    background-color: #212529 !important;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    padding: .75rem !important;
  }

  #calendario_agendar_siccij .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    text-shadow: none !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  #calendario_agendar_siccij .fc-state-active {
    background-color: rgb(174, 174, 174) !important;
  }

  #calendario_agendar_siccij .fc-button:focus {
    outline: none !important;
  }

  #calendario_agendar_siccij .fc-today {
    background-color: rgba(242,242,242,0.5) !important;
    color: white !important;
  }

  #calendario_agendar_siccij .fc-day-number {
    color: white !important;
  }

  #calendario_agendar_siccij .fc-event {
    background-color: #212529;
    border-color: #32383e !important;
    color: white !important;
    padding: 0 .375rem !important;
    font-size: 1.0em;
    border-radius: .25rem !important;
    width: 80% !important;
    text-align: center !important;
    margin: auto !important;
  }

  tr {
  }
</style>





// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ConsultaDeDictamenes/VerExpedienteElectronico.vue